import { View } from "react-native";
import ToggleImage from "src/components/ToggleImage";
import parseV0TemplateUrl from "src/helpers/parseV0TemplateUrl";
import useEditCoverGalleryStore from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryStore";
import { EditCoverPostersTabConfig } from "src/screens/(internal)/EditCoverGalleryModal/types";
import { radiusMedium } from "src/styles/radius";
import { EditCoverPosterListReadyItem } from "../types";

const EditCoverPoster = ({
	publicAsset,
	width,
	height,
	marginBottom,
	config,
}: {
	publicAsset: EditCoverPosterListReadyItem;
	width: number;
	height: number;
	marginBottom: number;
	config: EditCoverPostersTabConfig;
}) => {
	const src = parseV0TemplateUrl({
		readUrl: publicAsset.readUrl,
		aspectRatio: "1x1",
		strategy: "cover",
		size: "sm",
	});
	const selectCover = useEditCoverGalleryStore((state) => state.selectCover);
	const isSelected = useEditCoverGalleryStore((state) =>
		Boolean(
			state.selection &&
				state.selection.variant === "Posters" &&
				state.selection.publicAssetId === publicAsset.assetId,
		),
	);

	return (
		<View
			testID="Poster"
			style={{
				width,
				height,
				marginBottom,
			}}
		>
			{!!src && (
				<ToggleImage
					alt="Poster"
					toggleVariant="SingleSelect"
					src={src}
					dim={{
						width,
						height,
					}}
					containerStyle={{
						borderRadius: radiusMedium,
						overflow: "hidden",
					}}
					isSelected={isSelected}
					onPress={() => {
						selectCover({
							publicAssetId: publicAsset.assetId,
							variant: "Posters",
							url: src,
							config,
						});
					}}
					recyclingKey={publicAsset.assetId}
				/>
			)}
		</View>
	);
};
export default EditCoverPoster;
